import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface PortalAuthResponse {
  accessToken: string;
  customerId: number;
  organizationId: number;
  email: string;
}

export interface PortalDashboard {
  customerName: string;
  invoices: Array<{
    id: number;
    invoiceNumber: string;
    statusCode: string;
    totalAmount?: number;
    invoiceDate?: string;
  }>;
  openTickets: Array<{
    id: number;
    ticketNumber: string;
    subject: string;
    statusName?: string;
  }>;
  openTicketCount: number;
}

const portalClient = api;

export function setPortalToken(token: string | null) {
  if (token) {
    portalClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete portalClient.defaults.headers.common.Authorization;
  }
}

export const portalApi = {
  requestLink: (organizationId: number, email: string) =>
    unwrap(api.post<ApiResponse<{ status: string }>>('/v1/portal/auth/request-link', { organizationId, email })),

  verify: (token: string) =>
    unwrap(api.post<ApiResponse<PortalAuthResponse>>('/v1/portal/auth/verify', { token })),

  dashboard: () =>
    unwrap(portalClient.get<ApiResponse<PortalDashboard>>('/v1/portal/dashboard')),

  listTickets: () =>
    unwrap(portalClient.get<ApiResponse<import('@/types/desk').DeskTicket[]>>('/v1/portal/tickets')),

  createTicket: (body: { subject: string; description?: string }) =>
    unwrap(portalClient.post<ApiResponse<import('@/types/desk').DeskTicket>>('/v1/portal/tickets', body)),

  addComment: (ticketId: number, commentText: string) =>
    unwrap(portalClient.post<ApiResponse<null>>(`/v1/portal/tickets/${ticketId}/comments`, { commentText })),
};
